module.exports = __webpack_public_path__ + "img/04.c23cfa8f.jpg";